<template>
    <FormDialog
        :is-visible="isVisible" @abort="finish" @save="save"
        :title="model?.id ? 'Изменение устройства' : 'Новое устройство'"
    >
        <DeviceForm v-if="model" v-model="model" :errors="errors" />
    </FormDialog>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import {Device, DeviceDraft} from '@/models/Device'
import Editor from '@/mixins/Editor'
import FormDialog from '@/components/common/FormDialog.vue'
import DeviceForm from '@/components/forms/DeviceForm.vue'

@Component({
    components: {DeviceForm, FormDialog},
})
export default class DeviceEditor extends Editor<Device, DeviceDraft>
{
    async saveModel(device: DeviceDraft): Promise<Device> {
        return await this.api.setDevice(device)
    }

    getModelSavedMessage(device: Device): string {
        return `Устройство «${device.name}» сохранено`
    }
}
</script>
